export const NavLinks = [
    {
        id:1,
        title:"Home",
        path:"/"
    },
    {
        id:3,
        title:"Astrology",
        path:"/astrology"
    },      // {
    //     id:4,
    //     title:"Temples",
    //     path:"/temples"
    // },
    {
        id:5,
        title:"Live",
        path:"/live"
    },
    {
        id:6,
        title:"Panchang",
        path:"/panchang"
    },
    {
        id:7,
        title:"Library",
    },
]